export function getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
    return ''
}

export function getGoogleCID() {
    return getCookie('_ga').replace('GA1.1.', '')
}

export function getGoogleSessionId() {
    const match = document.cookie.match(/(?:^|; )(_ga_[^=]+)=([^;]*)/)
    if(!match) return ''
    return match[2].split('.')[2] || ''
}

export function getFbp() {
    return getCookie('_fbp')
}

export function getFbc() {
    return getCookie('_fbc')
}

export function getGclid() {
    // set by Google's auto-tagging (gtag.js), format: GCL.<timestamp>.<gclid>
    const cookie = getCookie('_gcl_aw')
    if(!cookie) return ''
    return cookie.split('.')[2] || ''
}

const MARKETING_ID_STORAGE_KEYS = {
    fbp: 'tb_fbp',
    fbc: 'tb_fbc',
    gaClientId: 'tb_ga_client_id',
    gaSessionId: 'tb_ga_session_id',
    utmSource: 'tb_utm_source',
    utmMedium: 'tb_utm_medium',
    utmCampaign: 'tb_utm_campaign',
    utmContent: 'tb_utm_content',
    utmTerm: 'tb_utm_term',
    gclid: 'tb_gclid',
}

export function saveMarketingId(key, value) {
    if(value) localStorage.setItem(MARKETING_ID_STORAGE_KEYS[key], value)
}

export function getMarketingId(key) {
    return localStorage.getItem(MARKETING_ID_STORAGE_KEYS[key]) || ''
}

export function pushToDataLayer(data, user = null) {
    try {
        if(!window?.dataLayer) return
        data.client_id = getMarketingId('gaClientId') || getGoogleCID()
        data.user_id = user?.id || null
        data.user_data = {
            user_id: user?.id || null,
            fbp: getMarketingId('fbp'),
            fbc: getMarketingId('fbc'),
            ga_client_id: getMarketingId('gaClientId') || getGoogleCID(),
            ga_session_id: getMarketingId('gaSessionId'),
            gclid: getMarketingId('gclid'),
            utm_source: getMarketingId('utmSource'),
            utm_medium: getMarketingId('utmMedium'),
            utm_campaign: getMarketingId('utmCampaign'),
            utm_content: getMarketingId('utmContent'),
            utm_term: getMarketingId('utmTerm'),
        }
        window.dataLayer.push(data)
        if(window?.parent) {
            window.parent.postMessage({
                type: 'push_to_datalayer',
                data
            }, 'https://topbilet.kz')
        }
    } catch (e) {
        console.log('error pushing to datalayer')
        console.error(e)
    }

}
